<template>
  <div class="spu-select">
    <div>
      <b>{{ config.categoryName ? '本次已选择：' : '请选择：' }}</b>
      {{ selectInfo }}
    </div>
    <el-tabs v-model="activeName">
      <el-tab-pane
        label="请选择品类"
        :disabled="categoryDisabled"
        name="1">
        <category-table
          ref="category"
          :config="config"
          @update="onUpdateConfig" />
      </el-tab-pane>
      <el-tab-pane
        label="请选择品牌"
        :disabled="!config.categoryId"
        name="2">
        <brand-table
          ref="brand"
          :config="config"
          @update="onUpdateConfig" />
      </el-tab-pane>
      <el-tab-pane
        label="请选择SPU"
        :disabled="!config.blandId"
        name="3">
        <spu-table
          ref="spu"
          :orderSource="orderSource"
          :config="config"
          @update="onUpdateConfig" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import CategoryTable from './category-table.vue'
import BrandTable from './brand-table.vue'
import SpuTable from './spu-table.vue'
export default {
  name: 'SpuSelect',
  components: { CategoryTable, BrandTable, SpuTable },
  props: {
    orderSource: { type: Number },
    categoryDisabled: { type: Boolean, default: false }
  },
  data() {
    return {
      visible: false,
      activeName: '1',
      config: { categoryId: null, categoryName: '', originalAppraisalItems: [], blandId: null, blandName: '', spuId: null, spuName: '' }
    }
  },
  computed: {
    selectInfo({ config }) {
      const { categoryName, blandName, spuName } = config
      let result = ''
      result = result + (categoryName ? `${categoryName}-` : '')
      result = result + (blandName ? `${blandName}-` : '')
      result = result + (spuName ? `${spuName}` : '')
      return result
    }
  },
  mounted() {
    if (!this.categoryDisabled) {
      this.$refs.category.fetchList()
    }
  },
  methods: {
    onUpdateConfig(config, name) {
      this.config = { ...this.config, ...config }
      if (name === 1) {
        setTimeout(() => {
          this.activeName = '2'
          this.$refs.brand.fetchList()
        }, 20)
      }
      if (name === 2) {
        setTimeout(() => {
          this.activeName = '3'
          this.$refs.spu.fetchList()
        }, 20)
      }
    },
    validate() {
      return new Promise((resolve, reject) => {
        const { categoryId, blandId, spuId } = this.config
        if (!!categoryId && !!blandId && !!spuId) {
          resolve(this.config)
        } else {
          reject()
        }
      })
    }
  }
}
</script>
